import styled from '@emotion/styled';
import { getConfig } from '@sortlist-frontend/config';
import { Tooltip } from '@sortlist-frontend/design-system/legacy';
import { ImageSourceHelper } from '@sortlist-frontend/media';

import { useSharedComponentsContext } from '../../utils';

const Flag = styled.img`
  height: 1.75rem;
  width: 1.5rem;
`;

type FeaturedFlagProps = {
  className?: string;
  isPrimary?: boolean;
};

export const FeaturedFlag = (props: FeaturedFlagProps) => {
  const { className, isPrimary } = props;
  const { t } = useSharedComponentsContext();
  const { publicEnv } = getConfig();

  const flagSrc = isPrimary ? 'featured-flag-primary' : 'featured-flag-secondary';

  return (
    <Tooltip placement="bottom" title={t('base:flags.featuredTooltip_v2')}>
      <Flag
        className={className}
        src={ImageSourceHelper.fromUrl(`${publicEnv.s3Bucket}/icons/flags/${flagSrc}.svg`)}
        alt="featured-flag"
      />
    </Tooltip>
  );
};
